import { useMemo } from 'react';

import { useAppConfig } from '@common/app-config';
import { isMobile as useIsMobile } from '@common/device-manager';
import { PdpWeekDayType, useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

import { useContactInfo } from '../queries/useContactInfoQuery';
import { BusinessDay, BusinessEtcDayType, getBusinessDayTransText } from '../utils/day_utils';

export const useContactService = () => {
  const { isZigzagApp } = useAppConfig();
  const isMobile = useIsMobile();

  const param = useCatalogProductIdParams();
  const { shop } = useContactInfo(param);

  const contactData = useMemo(() => {
    const { customer_center, main_contact, customer_center_tel } = shop;

    const getBusinessHour = () => {
      const { business_time, closed_week_day_list, is_closed_on_holiday, lunch_time } = customer_center ?? {};
      const result: string[] = [];

      if (business_time) {
        result.push(`평일 ${business_time.from_hm} ~ ${business_time.to_hm}`);
      }
      if (lunch_time) {
        result.push(`점심 ${lunch_time.from_hm} ~ ${lunch_time.to_hm}`);
      }

      if (closed_week_day_list && closed_week_day_list.length && is_closed_on_holiday !== null) {
        const refined_list: BusinessDay[] =
          closed_week_day_list.length === 2 &&
          closed_week_day_list.includes(PdpWeekDayType.SAT) &&
          closed_week_day_list.includes(PdpWeekDayType.SUN)
            ? [BusinessEtcDayType.WEEKEND]
            : closed_week_day_list;

        const refined_with_holiday = [
          ...refined_list,
          ...(is_closed_on_holiday ? [BusinessEtcDayType.PUBLIC_HOLIDAY] : []),
        ]
          .map((day) => getBusinessDayTransText(day))
          .join(', ');

        result.push(`${refined_with_holiday} 휴무`);
      }

      return result;
    };

    return {
      customer_center_tel,
      manager_name: customer_center?.manager_name,
      manager_tel: customer_center?.manager_tel,
      business_hours: getBusinessHour(),
      company_email: main_contact?.email,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shop]);

  return {
    isInApp: isZigzagApp,
    isMobile,
    contactData,
  };
};
